export default __webpack_public_path__ + "static/media/05.d425d1a8.jpg";